import { useOrderModal } from '@features/student/order/model/useOrderModal';
import { Alert } from '@shared/ui/alert/alert';
import React from 'react'
import { NavLink } from 'react-router-dom';
import s from './unpaid-order-alert.module.scss'

export const UnpaidOrderAlert = ({orderId}) => {
	const { open: openModal } = useOrderModal()

	return (
		<Alert
			title={"У вас есть неоплаченное занятие"}
			subtitle={
				<>
					Перед тем как забронировать новое занятие, оплатите или
					отмените неоплаченное:
					<NavLink className={s.payLink} onClick={() => openModal({orderId})}>Подробнее</NavLink>
				</>
			}
		/>
	)
}
